<template>
	<div class="footer">
		<div class="homebottom">
			<div align="center">
				Copyright © 1998-{{ newYear }} DRCnet. All Rights
				Reserved版权所有 国研网
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return { newYear: new Date().getFullYear() };
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>
<style lang="less" scoped>
.footer {
	// border-top: 6px solid #015293;
	min-width: 1200px;
	background: rgba(195, 0, 0, 1);
	padding: 30px;
	letter-spacing: 0.2px;
}

.homebottom {
	max-width: 950px;
	// padding-top: 20px;
	margin: auto;
	color: rgba(255, 255, 255, 1);
	font-size: 14px;
	line-height: 18px;
}

.homebottom a {
	color: rgba(255, 255, 255, 1);
	font-size: 14px;
}

.homebottom td a {
	text-decoration: underline;
	font-size: 12px;
}
.beian_a {
	background: url('@/assets/imgs/footer/filingForTheRecord.png') left center
		no-repeat;
	background-repeat: no-repeat;
	display: inline-block;
	text-decoration: none;
}
@media screen and (max-width: 769px) {
	.footer {
		min-width: 0;
		padding: 24px;
	}
	.homebottom table {
		width: 100%;
	}
}
</style>
